"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkerLabelChip = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Fonts = require("../constants/Fonts");
var _pittaModules = require("@thingsw/pitta-modules");
var _styles2 = require("@material-ui/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    root: {
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "3px 6px",
      minHeight: 23,
      maxWidth: 100,
      borderRadius: 4,
      backgroundColor: _pittaModules.LightColors.primary["0"],
      boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.14),\n      0px 1px 1px rgba(0, 0, 0, 0.12),\n      0px 0px 3px rgba(0, 0, 0, 0.2)",
      "&:focus": {
        border: "1px solid ".concat(_pittaModules.LightColors.primary["7"])
      },
      "&:hover": {
        border: "1px solid ".concat(_pittaModules.LightColors.primary["7"])
      },
      "&:active": {
        backgroundColor: _pittaModules.LightColors.primary["10"],
        "&>.label-active": {
          color: _pittaModules.LightColors.primary["7"]
        }
      }
    },
    //@ts-ignore
    camName: _objectSpread(_objectSpread({
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "center",
      width: 88,
      height: 12,
      textAlign: "center",
      alignItems: "center"
    }, _Fonts.Fonts.Default.Caption), {}, {
      fontFamily: "Roboto",
      fontSize: 11
    }),
    //@ts-ignore
    speed: _objectSpread(_objectSpread({
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "center",
      width: 88,
      height: 10,
      textAlign: "center",
      alignItems: "center"
    }, _Fonts.Fonts.Default.Caption), {}, {
      fontFamily: "Roboto",
      fontSize: 9,
      color: _pittaModules.LightColors.primary["2"],
      "&:hover": {
        color: _pittaModules.LightColors.primary["7"]
      }
    })
  });
});
var MarkerLabelChip = function MarkerLabelChip(props) {
  var theme = (0, _styles2.useTheme)();
  var classes = useStyle(props);
  var cam = props.cam,
    value = props.value,
    metric = props.metric;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.camName,
    dir: theme.direction
  }, "".concat(cam)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.speed, " label-active"),
    dir: theme.direction
  }, "".concat(value, " ").concat(metric)));
};
exports.MarkerLabelChip = MarkerLabelChip;